// extracted by mini-css-extract-plugin
export default {"spec":"WorkflowSpecification_spec__1+K50"};